import { Grid, Typography } from '@mui/material';
import { LightTooltip } from '@shared/components/grid/GridCell';
import { StyledTreeItemTitle } from '@styles/Admin-tools/MenuEditorStyles';
import { EMenuItemType, IChildMenuItemResponse } from '../types';
import { MENU_ITEM_ICONS } from '../constants';

export const TreeItemTitle = ({
  text,
  highlightColor1,
  highlightColor2,
  iconClass,
  menuItemType,
  link,
  queueId,
  disabled = true,
}: IChildMenuItemResponse) => {
  const Icon = !iconClass ? null : MENU_ITEM_ICONS[iconClass];

  return (
    <LightTooltip
      title="Please close the corresponding tab for this menu item to enable it."
      placement="top"
      disableHoverListener={disabled}
    >
      <StyledTreeItemTitle container alignItems="center" highlightColor1={highlightColor1} disabled={disabled}>
        <Grid item xs={1}>
          <Typography variant="body2">{Icon && <Icon />}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography variant="h5">{text}</Typography>
        </Grid>

        <Grid item xs={5}>
          <Typography variant="subtitle2">
            {menuItemType === EMenuItemType.Link && link}

            {menuItemType === EMenuItemType.Queue && queueId}
          </Typography>
        </Grid>

        <Grid item xs={2} style={{ backgroundColor: `${highlightColor2}20` }}>
          <Typography variant="body2" display="block" align="center" >
            Hover Color
          </Typography>
        </Grid>
      </StyledTreeItemTitle>
    </LightTooltip>
  );
};